import { Modal, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import SingleViewApis from '@/fetch/bussiness/singleView';
import { HttpStatusCode } from '@/fetch/core/constant';
const fetchApi = new SingleViewApis();
const CallFrontlinerModal = (props: {
  vehicleName: string;
  open: boolean;
  setOpen: AnyFunc;
}) => {
  const { vehicleName, open, setOpen } = props;
  const [selectUser, setSelectUser] = useState(0);
  const [currentPhone, setCurrentPhone] = useState(null);
  const [tableData, setTableData] = useState<
    {
      userName: any;
      realName: string;
      phone: any;
      stationId: any;
      erp: any;
    }[]
  >([]);

  const getAttentionUserList = async () => {
    try {
      const res = await fetchApi.getAttentionUser(vehicleName);
      if (res.code === HttpStatusCode.Success) {
        setTableData(res.data);
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    if (open) {
      getAttentionUserList();
    }
  }, [open]);
  const resetTableData = (list: any, updateSecret: Function) => {
    if (!list) {
      return [];
    }
    const newList: any[] = list.map((item: any) => {
      if (typeof item.secret === 'undefined') {
        item.secret = true;
      }
      return {
        ...item,
        phone: { item, updateSecret },
      };
    });
    return newList;
  };
  const getPhone = async () => {
    const res: any = await fetchApi.getAttentionUserPhone(vehicleName);
    if (res.code === HttpStatusCode.Success) {
      setCurrentPhone(res.data.phone);
    }
  };
  const updatePhoneSecret = (userName: any, secret: any) => {
    setTableData(
      tableData.map((item: any) => {
        if (item.userName === userName) {
          return {
            ...item,
            secret: secret,
          };
        } else {
          return {
            ...item,
            secret: true,
          };
        }
      }),
    );
  };
  const toggleShowOrHide = (userName: any, rowData: any) => {
    setSelectUser(userName);
  };
  const columns: any[] = [
    {
      dataIndex: 'userName',
      title: '姓名/erp',
      align: 'center',
      render: (text: string, record: any) => {
        const realName = String(record.realName);
        const erp = String(record.erp);
        const fullName = realName + '/' + erp;
        const encryptionName =
          realName.replace(realName.substring(1, realName.length), '****') +
          '/' +
          erp.replace(erp.substring(1, erp.length), '****');
        return (
          <>
            {selectUser === record.userName ? (
              <div
                className='encryption'
                onClick={toggleShowOrHide.bind(null, 0, record)}
              >
                {fullName}
                <span style={{ paddingLeft: '5px' }}>
                  <EyeOutlined />
                </span>
              </div>
            ) : (
              <div
                className='encryption'
                onClick={toggleShowOrHide.bind(null, record.userName, record)}
              >
                {encryptionName}
                <span style={{ paddingLeft: '5px' }}>
                  <EyeInvisibleOutlined />
                </span>
              </div>
            )}
          </>
        );
      },
    },
    {
      dataIndex: 'phone',
      title: '手机号',
      align: 'center',
      render: (params: any, record: any) => {
        return (
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'center',
            }}
          >
            {!params.item.secret && currentPhone
              ? currentPhone
              : params.item.phone}
            <div
              style={{ paddingLeft: '5px' }}
              onClick={() => {
                if (params.item.secret) {
                  getPhone();
                }
                params.updateSecret(record.userName, !params.item.secret);
                setCurrentPhone(null);
              }}
            >
              {params.item.secret ? <EyeInvisibleOutlined /> : <EyeOutlined />}
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <>
      <Modal
        open={open}
        title={'呼叫一线'}
        okText='关闭'
        onOk={() => {
          setOpen(false);
        }}
        onCancel={() => {
          setOpen(false);
        }}
      >
        <Table
          rowKey={'userName'}
          columns={columns}
          dataSource={resetTableData(tableData, (userName: any, secret: any) =>
            updatePhoneSecret(userName, secret),
          )}
          pagination={false}
          scroll={{
            y: '250px',
          }}
        ></Table>
      </Modal>
    </>
  );
};
export default React.memo(CallFrontlinerModal);
